<mat-card appearance="outlined">
    <app-transformer-top-header [isReadOnly]="isReadOnly" [viewModel]="viewModel" [transformslists]="transformslists" [iconpath]="iconpath" [nodeColor]="nodeColor" [transformNameType]="transformNameType" [aboutlink]="aboutlink"
    [refineryConfigGuid]="refineryConfigGuid" [refineryName]="refineryName" [nodeName]="nodeName" [nodeIndex]="nodeIndex" [configGuid]="configGuid" [cacheStatus]="cacheStatus" (onRefreshCacheStatus)="getCacheStatus()" (onPurgeCache)="purgeCache()"
    (onTransformTextChanged)="onTransformTextChanged()" 
    (onViewTransformConfigJson)="viewTransformConfigJson()" 
    (onRunTransform)="onRunTransformValidate()" 
    (onSaveConfig)="saveConfig()" (onShowTransformDetail)="showTransformDetail($event)" (onImportTransformer)="loadImportTransformer($event)" [hasResetSupport]="true" (onResetTransform)="resetTransformer()"
    [inputCacheKey]="copilotInputCacheKey"
    [sourceColumn]="viewModel?.parameters?.sourceColumn ?? ''"
    [availableSourceFields]="activityNamerAvailableSourceFields"
    [currentSampleStart]="viewModel?.parameters?.sampleStart ?? 0"
    [currentSampleEnd]="viewModel?.parameters?.sampleEnd ?? 0"
    (onApplySmartSample)="applySmartSample($event)"></app-transformer-top-header>

    <mat-card-content class="content-with-fixed-header">
        <!-- Description -->
        <mat-expansion-panel class="mat-elevation-z0" style="margin-top:5px;">
            <mat-expansion-panel-header>Description</mat-expansion-panel-header>
            <app-transformer-description [analystDescription]="viewModel.transform.analystDescription"
                (analystDescriptionChange)="viewModel.transform.analystDescription = $event"></app-transformer-description>
        </mat-expansion-panel>
        <!-- Parameters -->
        <mat-expansion-panel class="mat-elevation-z0" expanded style="margin-top:5px;">
            <mat-expansion-panel-header>Parameters<span *ngIf="isValidateParameters" class="mat-error" style="margin-left: 5px;">Missing Required Fields</span></mat-expansion-panel-header>
           <div style="margin-top:-10px;margin-left: -3px;">
            <app-transformer-parameters [viewModel]="viewModel.parameters" [sourceColumns]="viewModel.sourceColumnsDT" 
                (SetDefaultRule)="onSetDefaultRule($event)" 
                (ToggleRulesColumnDisplay)="onToggleRulesColumnDisplay()" 
                (formStatus)="onParameterFormStatusChange($event)"></app-transformer-parameters>
            <div style="display: flex">
                <div style="margin-right: 10px;">
                    <div style="display: flex; align-items: center;" [formGroup]="formparam">
                    <app-autocomplete-field-with-matform
                    formControlName="groupByField"
                    [options]="viewModel.OptionsourceColumns"
                     [placeholder]="groupBy.label|| 'Group By'"
                    [(ngModel)]="viewModel.groupBy"
                    [isrequired]="true"
                   
                ></app-autocomplete-field-with-matform>
                        <!-- <mat-form-field [formGroup]="formparam" appearance="legacy" style="width: 100%;">
                            <mat-label>{{groupBy.label}}</mat-label>
                            <mat-select required formControlName="groupByField" [(ngModel)]="viewModel.groupBy">
                                <mat-option *ngIf="groupBy.isselectblank"></mat-option>
                                <mat-option *ngFor="let col of viewModel.sourceColumns" [value]="col.text">
                                    {{col.text}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="formparam.get('groupByField').hasError('required')">{{viewModel.getValidationInfo('groupByField').errorMessage}}</mat-error>
                        </mat-form-field> -->
                        <div style="width: 24px;margin-left: 5px;"></div>
                    </div>
                     <div style="flex-basis: 100%; width: 100%;">
                <mat-error *ngIf="formparam.get('groupByField')?.hasError('required') && 
                                    formparam.get('groupByField')?.touched">
                    {{ groupBy.label }} is required
                </mat-error>
                </div>
                </div>
                <div style="margin-right: 10px;">
                    <div>
                        <mat-form-field>
                            <mat-label>{{defContainsInclude.label}}</mat-label>
                            <input matInput placeholder="Contains Include" type="number" [min]="defContainsInclude.min" [max]="defContainsInclude.max"
                                [(ngModel)]="viewModel.defContainsInclude" appIntegerPositiveOnly>
                        </mat-form-field>
                    </div>
                </div>
                <div style="margin-right: 10px;">
                    <div>
                        <mat-form-field>
                            <mat-label>{{defTimeout.label}}</mat-label>
                            <input matInput placeholder="Timeout" type="number" [min]="defTimeout.min" [max]="defTimeout.max"
                                [(ngModel)]="viewModel.defTimeout" appIntegerPositiveOnly>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            </div>
        </mat-expansion-panel>
        <!-- Advanced Settings -->
        <mat-expansion-panel class="mat-elevation-z0"  style="margin-top: 15px;">
            <mat-expansion-panel-header>Advanced Settings<span *ngIf="isValidateAdvanceSettings" class="mat-error" style="margin-left: 5px;">Missing Required Fields</span></mat-expansion-panel-header>
            <div style="display: flex;margin-top:-10px;margin-left: -2px;">
                <div style="margin-right: 10px;">
                    <div>
                        <mat-form-field [formGroup]="form">
                            <mat-label>{{bufferRows.label}}</mat-label>
                            <input matInput formControlName="bufferRows" type="number" placeholder="Buffer Rows" [(ngModel)]="viewModel.bufferRows" [required]="bufferRows.isrequired" [min]="bufferRows.min" [max]="bufferRows.max" appIntegerPositiveOnly>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field [formGroup]="form">
                            <mat-label>{{threads.label}}</mat-label>
                            <input matInput formControlName="threads" type="number" placeholder="Threads" [(ngModel)]="viewModel.threads" [required]="threads.isrequired" [min]="threads.min" [max]="threads.max" appIntegerPositiveOnly>
                        </mat-form-field>
                    </div>
                </div>
                <div style="margin-right: 10px;">
                    <div class="white-text-form">
                        <mat-form-field [formGroup]="form">
                            <mat-label>{{orderField.label}}</mat-label>
                            <mat-select [(ngModel)]="viewModel.orderField" [required]="orderField.isrequired" formControlName="orderField">
                                <mat-option *ngIf="orderField.isselectblank"></mat-option>
                                <mat-option *ngFor="let col of viewModel.targetColumns" [value]="col">{{col}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('orderField').hasError('required')">OrderField Field is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="white-text-form">
                        <mat-form-field [formGroup]="form">
                            <mat-label>{{isOpenField.label}}</mat-label>
                            <mat-select [(ngModel)]="viewModel.isOpenField" [required]="isOpenField.isrequired" formControlName="isOpenField">
                                <mat-option *ngIf="isOpenField.isselectblank"></mat-option>
                                <mat-option *ngFor="let col of viewModel.targetColumns" [value]="col">{{col}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('isOpenField').hasError('required')">IsOpenField Field is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="white-text-form">
                        <mat-form-field [formGroup]="form">
                            <mat-label>{{isCloseField.label}}</mat-label>
                            <mat-select [(ngModel)]="viewModel.isCloseField" [required]="isCloseField.isrequired" formControlName="isCloseField">
                                <mat-option *ngIf="isCloseField.isselectblank"></mat-option>
                                <mat-option *ngFor="let col of viewModel.targetColumns" [value]="col">{{col}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('isCloseField').hasError('required')">IsCloseField Field is required</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div style="margin-right: 10px;">
                    <div>
                        <mat-form-field [formGroup]="form">
                            <mat-label>{{separateBy.label}}</mat-label>
                            <mat-select [(ngModel)]="viewModel.separateBy" [required]="separateBy.isrequired" formControlName="separateBy">
                                <mat-select-trigger>
                                    <ng-container *ngIf="viewModel.separateBy === 'None'; else normalText">
                                        <span style="color: #9f9f9f">{{ viewModel.separateBy }}</span>
                                    </ng-container>
                                    <ng-template #normalText>
                                        {{ viewModel.separateBy }}
                                    </ng-template>
                                </mat-select-trigger>
                                <mat-option *ngIf="separateBy.isselectblank" value="None">None</mat-option>
                                <mat-option *ngFor="let col of viewModel.targetColumns" [value]="col">
                                    {{col}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('separateBy').hasError('separateBy')">Separate By Field is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field [formGroup]="form">
                            <mat-label>{{noGroupId.label}}</mat-label>
                            <input matInput formControlName="noGroupId" type="text" placeholder="{{noGroupId.label}}" [(ngModel)]="viewModel.noGroupId" [required]="noGroupId.isrequired">
                        </mat-form-field>
                    </div>
                    <!-- <div>
                        <mat-form-field [formGroup]="form">
                            <mat-label>{{noGroupIdTimeout.label}}</mat-label>
                            <input matInput formControlName="noGroupIdTimeout" type="number" placeholder="{{noGroupIdTimeout.label}}" [(ngModel)]="viewModel.noGroupIdTimeout" [required]="noGroupIdTimeout.isrequired" [min]="noGroupIdTimeout.min" [max]="noGroupIdTimeout.max" appIntegerPositiveOnly>
                        </mat-form-field>
                    </div> -->
                </div>
                <div style="margin-right: 10px;">
                    <div>
                        <mat-slide-toggle style="margin-top: 25px ;" labelPosition="before" color="primary" (change)="onToggleMultiTarget($event)" [checked]="viewModel.multiTargetColumn" >{{multiTargetColumn.label}}</mat-slide-toggle>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>
        <!-- Rules -->
        <mat-expansion-panel class="mat-elevation-z0" expanded style="padding-top: 10px;">
            <mat-expansion-panel-header>
                <div style="display: flex; align-items: center; justify-content: center;">
                    <span style="margin-right: 30px;">Rules</span>
                    <button class="add-rule-btn"  style="margin-right: 8px;"
                        color="primary" mat-raised-button (click)="$event.stopPropagation(); addNewRule()"
                        title="Add new rule" style="height: 24px;border-radius: 2px;">
                        <mat-icon >add_circle</mat-icon>
                        ADD RULE
                    </button>

                    <button (click)="$event.stopPropagation(); toggleRulesHeight();"
                       class="rule-toggle-btn" mat-raised-button color="primary"
                         title="Show All" style=" line-height: 24px;height: 24px;border-radius: 2px;">
                        <mat-icon style="font-size: 20px;margin-right:0px">{{isRulesMaximized ? 'unfold_less' : 'unfold_more'}}
                        </mat-icon>
                    </button>
                </div>
            </mat-expansion-panel-header>
            <div style="margin-top: 0px; margin-left: -6px; margin-right: -6px; padding-left: 2px; padding-right: 2px;" class="show-scrollbar"
                appMatTableAdjustRowHeight [RowCount]="isRulesMaximized ? maxrowcount : minrowcount" [MaxRowCount]="maxrowcount" [IsScrollBottom]="isScrollBottom">
                <h1 class="center" style=" color: lightgray" *ngIf="isRuleSetEmpty">No Rules</h1>

                <table *ngIf="!isRuleSetEmpty" (cdkDropListDropped)="dropTable($event)" mat-table
                    [dataSource]="dataSource" #table class="drag-list mat-elevation-z8" cdkDropList
                    [cdkDropListData]="dataSource">

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef class="no-padding-cell"> </th>
                        <td mat-cell *matCellDef="let rule" class="no-padding-cell">

                            <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center">
                             <!--   <mat-icon color="primary" matTooltip="Re-order Rule"  style="cursor: grab" cdkDrag [cdkDragData]="rule"
                                    cdkDragRootElement=".drag-component" cdkDragHandle>reorder</mat-icon>
                                <mat-icon style="margin-left: 4px; cursor: pointer" class="icon" (click)="onDuplicateRule(rule)" matTooltip="Duplicate Rule" color="primary">control_point_duplicate</mat-icon>
                                <mat-icon style="margin-left: 2px; cursor: pointer" (click)="onDeleteRule(rule)" matTooltip="Delete Rule" class="red-icon">delete_forever</mat-icon>
                            -->
                            <mat-icon color="primary"
                            style="cursor: grab" 
                            cdkDrag [cdkDragData]="rule"
                            cdkDragRootElement=".drag-component"
                            cdkDragHandle
                            matTooltip="Re-order Rule"  
                            matTooltipPosition="below"
                            #reorderTooltip="matTooltip"
                            (mouseenter)="reorderTooltip.show()"
                            (mouseleave)="reorderTooltip.hide()"
                            >reorder</mat-icon>

                            <mat-icon style="margin-left: 4px; cursor: pointer" 
                            class="icon" 
                            (click)="onDuplicateRule(rule)" 
                            matTooltip="Duplicate Rule" 
                            matTooltipPosition="below"
                            #duplicateTooltip="matTooltip"
                            (mouseenter)="duplicateTooltip.show(); 
                            reorderTooltip.hide()"
                            (mouseleave)="duplicateTooltip.hide()"
                            color="primary">
                            control_point_duplicate
                           </mat-icon>
                           <mat-icon style="margin-left: 2px; cursor: pointer"
                            (click)="onDeleteRule(rule)" 
                            matTooltip="Delete Rule" 
                            matTooltipPosition="below"
                            #deleteTooltip="matTooltip"
                            (mouseenter)="deleteTooltip.show(); duplicateTooltip.hide(); reorderTooltip.hide()"
                            (mouseleave)="deleteTooltip.hide()"
                            class="red-icon">
                            delete_forever
                        </mat-icon>
                            </div>


                           
                    </ng-container>

                    <ng-container matColumnDef="index">
                        <th mat-header-cell *matHeaderCellDef> Rule </th>
                        <td mat-cell *matCellDef="let rule"> {{rule.index}} </td>
                        <mat-icon cdkDragHandle>reorder</mat-icon>
                    </ng-container>

                    <ng-container matColumnDef="ruleName">
                        <th mat-header-cell *matHeaderCellDef> Rule Name </th>
                        <td mat-cell *matCellDef="let rule"><input type="text"
                                style="border: none; box-sizing: border-box" [(ngModel)]="rule.name" appAutowidth>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="sourceColumn">
                        <th mat-header-cell *matHeaderCellDef> Source Field </th>
                        <td mat-cell *matCellDef="let rule" class="auto-width">
                             <!-- <mat-select [(ngModel)]="rule.sourceColumn">
                                <mat-option *ngFor="let col of viewModel.sourceColumns" [value]="col.text">{{col.text}}
                                </mat-option>
                            </mat-select>  -->
                              <app-autocomplete-field 
                                [options]="options"    
                                [placeholder]="defaultSourceColumn" 
                                [(ngModel)]="rule.sourceColumn"
                                ></app-autocomplete-field> 
                        </td>
                        <mat-icon cdkDragHandle>reorder</mat-icon>
                    </ng-container>

                    <ng-container matColumnDef="startsAt">
                        <th mat-header-cell *matHeaderCellDef style="border-left: 2px solid #ffa600;"> Starts At </th>
                        <td mat-cell *matCellDef="let rule" style="border-left: 2px solid #ffa600;">
                            <mat-select [(ngModel)]="rule.startAt">
                                <!-- <mat-option></mat-option> -->
                                <mat-option *ngFor="let ruleType of StartsAtRuleTypes" [value]="ruleType">
                                    {{GroupStartAtTypeUtil.toString(ruleType)}}
                                </mat-option>
                            </mat-select>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="endsAt">
                        <th mat-header-cell *matHeaderCellDef> Ends At </th>
                        <td mat-cell *matCellDef="let rule" class="auto-width">
                            <mat-select [(ngModel)]="rule.endAt" >
                                <!-- <mat-option></mat-option> -->
                                <mat-option *ngFor="let ruleType of EndsAtRuleTypes" [value]="ruleType">
                                    {{GroupEndAtTypeUtil.toString(ruleType)}}
                                </mat-option>
                            </mat-select>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="activityName">
                        <th mat-header-cell *matHeaderCellDef> Activity Name </th>
                        <td mat-cell *matCellDef="let rule">
                            <div [matTooltip]="rule.tooltipMessageresult" matTooltipPosition="right" 
                                [matTooltipClass]="rule.tooltipTyperesult === 'red' ? 'warning-tooltip-red' : ''"
                                [matTooltipDisabled]="!rule.tooltipMessageresult"
                                [ngStyle]="getTooltipStyleActivityName(rule)">
                                <input type="text" style="border: none; box-sizing: border-box" [(ngModel)]="rule.result" appAutowidth>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="contains">
                        <th mat-header-cell *matHeaderCellDef class="fixed-width-column"> Contains </th>
                        <td mat-cell *matCellDef="let rule" style="cursor: pointer;" class="fixed-width-column text-overflow"
                            (click)="onContainsCellClicked(rule)">
                            <div [matTooltip]="rule.tooltipMessageContains" matTooltipPosition="right" 
                                [matTooltipClass]="rule.tooltipTypeContains === 'red' ? 'warning-tooltip-red' : ''"
                                [matTooltipDisabled]="!rule.tooltipMessageContains"
                                [ngStyle]="getTooltipStyleContains(rule)">
                                <span *ngIf="rule.containsList?.length === 0"
                                    style="margin-left: 2px; margin-right: 2px; color: #ffa600; font-size:10px; white-space: pre;">Tap
                                    to Edit</span>
                                <span style="margin-left: 2px; margin-right: 2px; white-space: pre;" 
                                    *ngFor="let containItem of rule.containsList"
                                    [style.color]="containItem.color.color">{{containItem.text }} </span>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="includeAfter">
                        <th mat-header-cell *matHeaderCellDef  style="text-align: center;"> Contains Include </th>
                        <td mat-cell *matCellDef="let rule">
                            <input 
                                [disabled]="rule.startAt === RuleType.group && rule.endAt === RuleType.group" 
                                type="number" [min]="0"
                                style="border: none; width:45px; box-sizing: border-box"
                                [(ngModel)]="rule.includeAfter" appIntegerPositiveOnly></td>
                    </ng-container>

                    <ng-container matColumnDef="timeout">
                        <th mat-header-cell *matHeaderCellDef style="border-left: 2px solid #ffa600;"> Timeout (m) </th>
                        <td mat-cell *matCellDef="let rule" style="border-left: 2px solid #ffa600;">
                            <input type="number" [min]="0" style="border: none; width:45px; box-sizing: border-box;" [(ngModel)]="rule.timeoutMs" appIntegerPositiveOnly>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="logicalOperator">
                        <th mat-header-cell *matHeaderCellDef> AND/OR </th>
                        <td mat-cell *matCellDef="let rule" class="auto-width">
                            <mat-select [(ngModel)]="rule.andOr" [disabled]="checkContainsListLength(rule)">
                                <!-- <mat-option></mat-option> -->
                                <mat-option [value]=true>AND</mat-option>
                                <mat-option [value]=false>OR</mat-option>
                            </mat-select>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="matchCase">
                        <th mat-header-cell *matHeaderCellDef style="text-align: center;width: 40px;"> Match Case </th>
                        <td mat-cell *matCellDef="let rule"  style="text-align: right;width: 40px;">
                            <mat-slide-toggle color="primary" [(ngModel)]="rule.matchCase"></mat-slide-toggle>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="isEnabled">
                        <th mat-header-cell *matHeaderCellDef>  <span style="margin-bottom: 2px; text-align: left;width: 40px;margin-right: 10px;">Run?</span> <mat-slide-toggle (change)="onRunChanged($event)"
                                color="primary"></mat-slide-toggle>
                        </th>
                        <td mat-cell *matCellDef="let rule"style="text-align: right;width: 40px;">
                            <mat-slide-toggle color="primary" [(ngModel)]="rule.run"></mat-slide-toggle>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="sampleGroups">
                        <th mat-header-cell style="border-left: 2px solid #ffa600;text-align: center;" *matHeaderCellDef> Sample Group Hits
                        </th>
                        <td mat-cell style="border-left: 2px solid #ffa600;" *matCellDef="let rule">
                            {{rule.sampleGroupHits | number}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="sampleRows">
                        <th mat-header-cell *matHeaderCellDef  style="text-align: center;"> Sample Row Hits</th>
                        <td mat-cell *matCellDef="let rule"> {{rule.sampleRowHits | number}} </td>
                    </ng-container>

                    <ng-container matColumnDef="groups">
                        <th mat-header-cell *matHeaderCellDef> Total Group Hits</th>
                        <td mat-cell *matCellDef="let rule"> {{rule.groupHits | number}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="rows">
                        <th mat-header-cell *matHeaderCellDef> Total Row Hits</th>
                        <td mat-cell *matCellDef="let rule"> {{rule.rowHits | number}} </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
                   <!-- <tr class="drag-component" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>-->
                    <tr
                class="drag-component"
                mat-row
                *matRowDef="let row; columns: displayedColumns;"
                (click)="onRowClicked($event, row)"
                [ngClass]="{'highlight-row': selectedRows.includes(row)}">
                </tr>


                    <div *cdkDragPlaceholder></div>

                </table>
            </div>
        </mat-expansion-panel>
        <!-- Results Dashboard -->
        <mat-expansion-panel class="mat-elevation-z0" [expanded]="isResultsPanelExpanded">
            <mat-expansion-panel-header (click)="setActivityNamerResultsTabClicked()">Results Dashboard</mat-expansion-panel-header>
            <mat-tab-group animationDuration="300ms" [(selectedIndex)]="resultsDashboardTabIndex">
                <mat-tab label="Results">
                    <div style="position: relative">
                        <div style="position: absolute;left:200px;top: 4px; ">
                            <mat-form-field style="width: 120px" appearance="outline">
                                <mat-label>Farm Rows</mat-label>
                                <input readonly matInput placeholder="Rows" type="text" [value]="viewModel.rows | number">
                            </mat-form-field>
                            <mat-form-field style="width: 110px; margin-left: 3px;" appearance="outline">
                                <mat-label>Group Hits</mat-label>
                                <input type="text" readonly matInput placeholder="Hits"
                                    [value]="viewModel.groupHitCount | number">
                            </mat-form-field>
                            <mat-form-field style="width: 92px; margin-left: 3px;" appearance="outline">
                                <mat-label>Row Hits</mat-label>
                                <input type="text" readonly matInput placeholder="Hits" [value]="viewModel.hitCount | number">
                            </mat-form-field>
                            <mat-form-field style="width: 130px; margin-left: 3px;" appearance="outline">
                                <mat-label>Row Hit Ratio</mat-label>
                                <input type="text" readonly matInput placeholder="Row Hit Ratio"
                                    [(ngModel)]="viewModel.hitRatioDisplay">
                            </mat-form-field>
                            <mat-form-field style="width: 90px; margin-left: 3px;" appearance="outline">
                                <mat-label>Misses</mat-label>
                                <input type="text" readonly matInput placeholder="Misses"
                                    [value]="viewModel.missCount | number">
                            </mat-form-field>
                            <mat-form-field *ngIf="lastDtrRunTime" style="width: 120px; margin-left: 3px;" appearance="outline">
                                <mat-label>Uncompiled</mat-label>
                                <input type="text" readonly matInput [value]="lastDtrRunTime"
                                    matTooltip="Run Time (uncompiled) — time taken by the generic engine to execute this transform" matTooltipPosition="above">
                            </mat-form-field>
                            <mat-form-field *ngIf="lastDtrRunTime && isCompilable" style="width: 120px; margin-left: 3px;" appearance="outline">
                                <mat-label>When compiled</mat-label>
                                <input type="text" readonly matInput [value]="lastCompiledRunTime"
                                    matTooltip="Preview only — how fast the compiled fast-path engine would run this transform's CURRENT config (saved or not), not necessarily what production is using right now. Save to make this the actual compiled plan production runs. NA when the config isn't fully compilable or its own Run All Rows setting is off." matTooltipPosition="above">
                            </mat-form-field>
                        </div>
                        <app-preview-table [delegate]="this" #previewTable [hideRefresh]="true" [hideOptions]="true" previewType="temptransResult" previewTypeName="Result"
                            [viewModel]="previewDataViewModel"  ></app-preview-table>
                    </div>
                </mat-tab>
                <mat-tab label="Summary">
                    <button mat-raised-button color="primary" [matMenuTriggerFor]="menusummaryResult" #menuTriggerResult="matMenuTrigger"  style="margin-top: 3px;margin-left: 20px;margin-right: 50px;" (click)="showSelectFilterResult(menuTriggerResult)">Summary Fields</button>
                    <span>{{ totalSummaryRowsResult }}</span>
                    <mat-menu #menusummaryResult="matMenu" yPosition="below" style="margin-top: 2% !important;">
                        <app-select-filter-option [values]="selectValuesResult" [valuesColor]="selectValuesColorResult" [sources]="datafarmSourcesResult" [source]="sourceResult" [emptyColumns]="selectEmptyColumnsResult" [selectedColumns]="selectFilterValuesResult" columnName="Summary" (clearFilter)="onClearSelectResult($event)" (applyFilter)="onApplySelectResult($event)" (closeFilter)="onCloseSelectResult()"></app-select-filter-option>
                    </mat-menu>
                    <app-preview-table style="width: 100px;" [delegate]="this" #summaryDataFarmPreviewTableResult [hideRefresh]="true" previewType="Summary" 
                        [hideOptions]="true" [viewModel]="previewDataViewModel" [widthOptions]="true"  ></app-preview-table>
                </mat-tab>
            </mat-tab-group>
        </mat-expansion-panel>
        <!-- Data Farm Preview -->
        <mat-expansion-panel class="mat-elevation-z0" [expanded]="isPreviewPanelExpanded">
            <mat-expansion-panel-header (click)="setActivityNamerPreviewTabClicked()">Data Farm Preview</mat-expansion-panel-header>
            <mat-tab-group animationDuration="300ms" (selectedTabChange)="onTabClick($event)">
                <mat-tab label="Input ({{inputcolumncount}})">
                    <div style="position: relative;">
                        <app-preview-table [delegate]="this" #inputDataFarmPreviewTable [hideRefresh]="true"
                            [hideOptions]="true" [viewModel]="previewDataViewModel" previewType="transInput" previewTypeName="Input"  ></app-preview-table>
                    </div>
                </mat-tab>
                <mat-tab label="Output ({{outputcolumncount}})">
                    <app-preview-table [delegate]="this" #outputDataFarmPreviewTable [hideRefresh]="true"
                        [hideOptions]="true" [viewModel]="previewDataViewModel" previewType="temptransOutput" previewTypeName="Output"  ></app-preview-table>
                </mat-tab>
                <mat-tab label="Summary (Input)">
                    <button mat-raised-button color="primary" [matMenuTriggerFor]="menusummaryinput" #menuTriggerInput="matMenuTrigger"  style="margin-top: 3px;margin-left: 20px;margin-right: 50px;" (click)="showSelectFilter(menuTriggerInput,'Input')">Summary Fields</button>
                    <span>{{ totalSummaryRowsInput }}</span>
                    <mat-menu #menusummaryinput="matMenu" yPosition="below" style="margin-top: 2% !important;">
                        <app-select-filter-option [values]="selectValuesInput" source="Input" [emptyColumns]="selectEmptyColumnsInput" [selectedColumns]="selectFilterValuesInput" columnName="Summary" (clearFilter)="onClearSelect($event)" (applyFilter)="onApplySelect($event)" (closeFilter)="onCloseSelect()" (changeSource)="onChangeSource($event)"></app-select-filter-option>
                    </mat-menu>
                    <app-preview-table style="width: 100px;" [delegate]="this" #summaryDataFarmPreviewTableInput [hideRefresh]="true" previewType="Summary" 
                        [hideOptions]="true" [viewModel]="previewDataViewModel" [widthOptions]="true"  ></app-preview-table>
                </mat-tab>
                <mat-tab label="Summary (Output)">
                    <button mat-raised-button color="primary" [matMenuTriggerFor]="menusummaryoutput" #menuTriggerOutput="matMenuTrigger"  style="margin-top: 3px;margin-left: 20px;margin-right: 50px;" (click)="showSelectFilter(menuTriggerOutput,'Output')">Summary Fields</button>
                    <span>{{ totalSummaryRowsOutput }}</span>
                    <mat-menu #menusummaryoutput="matMenu" yPosition="below" style="margin-top: 2% !important;">
                        <app-select-filter-option [values]="selectValuesOutput" source="Output" [emptyColumns]="selectEmptyColumnsOutput" [selectedColumns]="selectFilterValuesOutput" columnName="Summary" (clearFilter)="onClearSelect($event)" (applyFilter)="onApplySelect($event)" (closeFilter)="onCloseSelect()" (changeSource)="onChangeSource($event)"></app-select-filter-option>
                    </mat-menu>
                    <app-preview-table style="width: 100px;" [delegate]="this" #summaryDataFarmPreviewTableOutput [hideRefresh]="true" previewType="Summary" 
                        [hideOptions]="true" [viewModel]="previewDataViewModel" [widthOptions]="true"  ></app-preview-table>
                </mat-tab>
            </mat-tab-group>
        </mat-expansion-panel>
        <!-- Data Farm Export -->
        <mat-expansion-panel [disabled]="isDisabled" [expanded]="!isDisabled" class="mat-elevation-z0">
            <mat-expansion-panel-header (click)="DataFarmExport()">Data Farm Export</mat-expansion-panel-header>
            <app-export-output-data #exportOutputData [hideOptions]="true" 
            [viewModelExport]="viewModelExport"></app-export-output-data>
        </mat-expansion-panel>
    </mat-card-content>
</mat-card>